import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const BotMessage = ({ message }) => {
  return (
    <div className={`message-bubble bot-message ${message.position}`} role="article" aria-label="Bot response">
      <div className="message-content">
        <ReactMarkdown 
          key={message.id}
          remarkPlugins={[remarkGfm]}
          components={{
            p: ({children}) => <p className="markdown-paragraph">{children}</p>,
            ul: ({children}) => <ul className="markdown-list">{children}</ul>,
            ol: ({children}) => <ol className="markdown-list">{children}</ol>,
            li: ({children}) => <li className="markdown-list-item">{children}</li>,
            h1: ({children}) => <h1 className="markdown-heading">{children}</h1>,
            h2: ({children}) => <h2 className="markdown-heading">{children}</h2>,
            h3: ({children}) => <h3 className="markdown-heading">{children}</h3>,
            strong: ({children}) => <strong className="markdown-bold">{children}</strong>,
            em: ({children}) => <em className="markdown-italic">{children}</em>,
            code: ({children}) => <code className="markdown-code">{children}</code>,
            pre: ({children}) => <pre className="markdown-pre">{children}</pre>,

            a: ({href, children}) => (
              <a 
                href={href} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="markdown-link"
              >
                {children}
              </a>
            ),
          }}
          remarkRehypeOptions={{
            allowDangerousHtml: true
          }}
        >
          {message.text || ''}
        </ReactMarkdown>
        {message.citations && message.citations.length > 0 && (
          <div className="citations-section">
            <h4 className="citations-header">Sources</h4>
            <div className="citations">
              {message.citations.map((citation, i) => (
                <a
                  key={`${citation.url}-${i}`}
                  href={citation.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="citation-link"
                  aria-label={`${citation.title || 'Learn more'} - opens in new tab`}
                >
                  {citation.title || 'Learn more'}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="message-date">{message.date.toLocaleTimeString()}</div>
    </div>
  );
};

export default BotMessage;